document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".js-clickable-button");
  const plans = document.querySelectorAll(".js-plan-select");
  const sizes = document.querySelectorAll(".js-size-option");
  const subscriptionForm = document.querySelector('.js-single-subscription-form');
  const quantityBtns = document.querySelectorAll('.subscription-quantity-btn');
  const atcSubscriptionBtns = document.querySelectorAll('.js-atc-subscription');
  const dropdownToggle = document.getElementById("option-sizes");
  const dropdownList = document.querySelector(".dropdown-list-sizes");
  const radioButtons = document.querySelectorAll(".sizes-name");


  plans.forEach((plan) => {
    const button = plan.querySelector(".js-select-button");
    button.dataset.originalText = button.textContent;
    if (plan.classList.contains("active")) {
      button.textContent = "selected";
    }
    plan.addEventListener("click", () => handleCardClick(button, plan));
  });

  // Events

  function activateAtcBtn() {
    const atcBtn = document.querySelector(".js-button-atc-lp")
    atcBtn.classList.remove("disable-atc-subscription");
  }

  function handleCardClick(button, plan) {
    plans.forEach((p) => {
      p.classList.remove("active");
      const btn = p.querySelector(".js-select-button");
      btn.textContent = btn.dataset.originalText;
    });
    plan.classList.add("active");
    button.textContent = "selected";

    // set the sizes options
    const atcBtn = plan.querySelector('.js-atc-subscription');
    const options = atcBtn.getAttribute('data-size-variants-names').split(' ');
    const container = document.querySelector('.js-options-container');

    const currentOptionSelected = container.querySelector('input[name="size"]:checked')?.value;
    container.innerHTML = '';
    options.forEach((size, index) => {
      // Create label element
      const label = document.createElement('label');
      label.classList.add('dropdown-list-item');

      // Create input element
      const input = document.createElement('input');
      const span = document.createElement('span');
      span.classList.add('radio-custom');
      input.type = 'radio';
      input.name = 'size';
      input.value = size;
      input.classList.add('sizes-name');
      input.checked = size === currentOptionSelected;
      input.addEventListener("click", activateAtcBtn)
      input.addEventListener("change", hadleSizeChange)


      // Append input to label and add size text
      label.appendChild(input);
      label.appendChild(span);
      label.append(size);

      // Append label to container
      container.appendChild(label);

      // Check if atc should be sold out
      const options = atcBtn.getAttribute('data-size-variants-names')?.split(' ');
      const availability = atcBtn.getAttribute('data-size-variants-availability')?.split(' ');
      const optionsAvailability = options.map((option, index) => ({ option, availability: availability[index] }));

      // Add the sold out class to the atc button handler
      const optionsSelectedAvailability = optionsAvailability.find((option) => option.option == currentOptionSelected);
      const atcSubBtn = document.querySelector(".js-button-atc-lp")

      if (optionsSelectedAvailability?.availability === 'false') {
        atcSubBtn.classList.add('disable-atc-subscription');
        atcSubBtn.textContent = atcSubBtn.getAttribute('data-sold-out-text');
      } else {
        atcSubBtn.classList.remove('disable-atc-subscription');
        atcSubBtn.textContent = atcSubBtn.getAttribute('data-atc-text');
      }

    });
  }

  function handleSubscripType() {
    buttons.forEach((btn) => btn.classList.remove("active"));
    this.classList.add("active");
  }

  function handleAtcCart(ev) {
    const productTile = ev.target.closest('.container-plan');
    const atcBtn = productTile.querySelector('.js-atc-subscription');
    const variantNames = atcBtn.getAttribute('data-size-variants-names')?.split?.(' ');
    const variantIndex = variantNames.findIndex((variant) => variant.toLowerCase?.() === window.subscriptionId?.toLowerCase?.())
    const variantId = atcBtn.getAttribute('data-size-variants')?.split?.(' ')[variantIndex];
    const id = variantId || atcBtn.getAttribute('data-product');
    const selling_plan = atcBtn.getAttribute('data-selling_plan');
    const quantity = window.subscriptionQuantity || 1;

    window?.cartEvents('cart:updating');

    return fetch(window.paths.add, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, selling_plan, quantity }),
    })
      .then((r) => r.json())
      .then((item) => {
        return window?.getCart?.().then((cart) => {
          window?.cartEvents('cart:updated', {
            cart: window?.sortCart?.(cart),
            cartOpen: true,
          });
          window?.cartEvents('cart:toggle', () => ({ cartOpen: true }));
        });
      })
      .catch((err) => {
        console.error('Fetch error:', err);
        alert('There was an error updating the cart. Please try again.');
      });
  }

  function handleQuantityChange(ev) {
    const input = ev.target.parentElement.querySelector('input');
    const button = (ev.target.classList.contains('js-plus') || ev.target.classList.contains('js-minus')) ? event.target : ev.target.closest('.plus, .minus');
    const value = parseInt(input.value) || 1;

    if (button.classList.contains('js-plus')) {
      input.value = value + 1;
    } else if (button.classList.contains('js-minus')) {
      if (value > 1) {
        input.value = value - 1;
      }
    }
  }

  function handleFormSubmit(ev) {
    ev.preventDefault();
    const selectedTile = document.querySelector('.container-plan.active');
    if (!selectedTile) {
      alert('Please select a subscription plan.');
      return;
    }
    const atcBtn = selectedTile.querySelector('.js-atc-subscription');
    window.subscriptionQuantity = ev.target.querySelector('.subscription-quantity').value;
    window.subscriptionId = ev.target.querySelector('input[name="size"]:checked').value;
    if (!window.subscriptionId) return
    atcBtn.click();
  }

  function hadleSizeChange() {
    dropdownList.style.display = "none";
    dropdownToggle.checked = false;


    // Check if atc should be sold out
    const container = document.querySelector('.js-options-container');
    const currentOptionSelected = container.querySelector('input[name="size"]:checked')?.value;

    const activeCard = document.querySelector('.container-plan.active');
    const atcBtn = activeCard.querySelector('.js-atc-subscription');
    const options = atcBtn.getAttribute('data-size-variants-names')?.split(' ');
    const availability = atcBtn.getAttribute('data-size-variants-availability')?.split(' ');
    const optionsAvailability = options.map((option, index) => ({ option, availability: availability[index] }));

    const optionsSelectedAvailability = optionsAvailability.find((option) => option.option == currentOptionSelected);
    const atcSubBtn = document.querySelector(".js-button-atc-lp")

    if (optionsSelectedAvailability.availability === 'false') {
      atcSubBtn.classList.add('disable-atc-subscription');
      atcSubBtn.textContent = atcSubBtn.getAttribute('data-sold-out-text');
    } else {
      atcSubBtn.classList.remove('disable-atc-subscription');
      atcSubBtn.textContent = atcSubBtn.getAttribute('data-atc-text');
    }

  }

  sizes.forEach((size) => {
    size.addEventListener("click", activateAtcBtn)
  });


  buttons.forEach((button) => {
    button.addEventListener("click", handleSubscripType);
  });

  atcSubscriptionBtns.forEach((btn) => {
    btn.addEventListener('click', handleAtcCart);
  });

  if (subscriptionForm) {
    subscriptionForm.addEventListener('submit', handleFormSubmit);
  }

  quantityBtns.forEach((btn) => {
    btn.addEventListener('click', handleQuantityChange);
  });

  // Dropdwn sizes hidden
  dropdownToggle.addEventListener("change", () => {
    dropdownList.style.display =
      dropdownList.style.display === "flex" ? "none" : "flex";
  });

  radioButtons.forEach((radio) => {
    radio.addEventListener("change", hadleSizeChange);
  });
});
